import { getStates as _getStates, getCountryList } from '../services/api/profile.service';

//Function added for making a string first letter to upper case
String.prototype.capitalize = function () {
  return `${this[0].toUpperCase()}${this.slice(1)}`;
};

const countryWithStates = ['US', 'CA'];

const statesOfCountries = {};
let countryList = [];

export const getStates = async (countryCode) => {
  if (!statesOfCountries[countryCode]) {
    const states = await _getStates(countryCode);
    if (states) {
      statesOfCountries[countryCode] = states.map((i) => ({
        label: i.StateName,
        value: i.StateCode,
      }));
    } else {
      // if api fails it returns null, so we will return empty array to prevent null exceptions up the chain
      return [];
    }
  }

  return statesOfCountries[countryCode];
};

export const getCountries = async () => {
  if (countryList.length === 0) {
    const countries = await getCountryList();
    if (countries) {
      countryList = countries.map((i) => ({
        label: i.CountryName,
        value: i.CountryCode,
      }));
    }
  }

  return countryList;
};

export const hasRegisteredStates = (country) => {
  return countryWithStates.includes(country);
};
